import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Components
 */
import DocumentCard from './DocumentCard';

const styles = {
    documentList: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
};

/**
 * List of Work documents
 * @component
 * @param {Object[]} items the documents
 */
const ListDocuments = ({ items }) => {
    const { t } = useTranslation();

    if (!Array.isArray(items) || items.length < 1) {
        return (
            <div>{t('noResults')}</div>
        );
    }

    return (
        <div style={styles.documentList}>
            {items.map(item => (
                <DocumentCard key={item.id} document={item} />
            ))}
        </div>
    );
};

export default ListDocuments;

